module.exports = __webpack_public_path__ + "static/img/jp1.5e138dcb.png";